import { Injectable } from '@angular/core';
import { BrandingV2Service } from '@galaxy/partner';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImageService {
  constructor(private brandingService: BrandingV2Service) {}

  public getImageSrc(imageName: string): string {
    if (window.location.hostname === 'localhost') {
      return `/assets/${imageName}`;
    }
    return `https://vstatic-prod.apigateway.co/business-center-client.9223372035143138814.prod/assets/${imageName}`;
  }

  public getPartnerMarketLogoImage(partnerId: string, marketId: string): Observable<string> {
    return this.brandingService.getBranding(partnerId, marketId).pipe(
      take(1),
      map((branding) => branding?.logoUrl),
    );
  }
}
